import { Card, ListGroup } from 'react-bootstrap';

function Assignments() {
  return (
    <Card className="shadow-sm p-4">
      <h4>Your Assignments</h4>
      <ListGroup className="mt-3">
        <ListGroup.Item>Math Assignment - Due 5th Nov</ListGroup.Item>
        <ListGroup.Item>Science Project - Due 10th Nov</ListGroup.Item>
        <ListGroup.Item>English Essay - Due 12th Nov</ListGroup.Item>
      </ListGroup>
    </Card>
  );
}

export default Assignments;
